export enum IActivityTypes {
  // Mapped to Postgres table "tracked_activities" row "table_name"
  surveys = 'surveys',
  published_events = 'published_events',
  events = 'events',
  sessions = 'sessions',
  page_modules = 'page_modules',
  scheduled_emails = 'scheduled_emails',
}

export interface IReturnableActivity {
  timestamp_id: number;
  uuid: string;
  bl_admin: number;
  action: string;
  name: string;
  timestamp: string;
  type: IActivityTypes;
}

export interface IGetActivityLogResponse {
  next: number;
  activities: IReturnableActivity[];
}
